/* eslint-disable no-shadow */
/* eslint-disable object-curly-newline */
/* eslint-disable camelcase */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import YouTube from 'react-youtube';
import { toast } from 'react-toastify';
import AceEditor from 'react-ace';

import { Container, Header, ButtonTest } from './styles';

import history from '~/services/history';
import api from '~/services/api';

export default function UpdateChallenge() {
  const { id } = useParams();
  const [challenge, setChallenge] = useState('');
  const [module, setModule] = useState('');
  const [type, setType] = useState('');
  const [position, setPosition] = useState('');
  const [title, setTitle] = useState('');
  const [question, setQuestion] = useState('');
  const [description, setDescription] = useState('');
  const [link, setLink] = useState('');
  const [code, setCode] = useState('');
  const [language, setLanguage] = useState('');
  const [textHelp, setTextHelp] = useState('');
  const [answer, setAnswer] = useState('');

  useEffect(() => {
    async function getDataChallenge() {
      const { data } = await api.get(`/challenges/${id}`);
      setChallenge(data);
      setModule(data.module);
      setType(data.type);
      setPosition(data.position);
      setTitle(data.title);
      setQuestion(data.question);
      setDescription(data.description);
      setLink(data.link_question);
      setCode(data.ace_editor);
      setLanguage(data.language);
      setTextHelp(data.help);
      setAnswer(data.answer);
    }

    getDataChallenge();
  }, [id]);

  function onLoad() {}

  function onChangeCode(newValue) {
    setCode(newValue);
  }

  function onChangeAnswer(newValue) {
    setAnswer(newValue);
  }

  async function handleSelectType(e) {
    setType(e.target.value);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      await api.put(`/challenges/${id}`, {
        type,
        position,
        title,
        question,
        description,
        link_question: link,
        ace_editor: code,
        language,
        help: textHelp,
        answer,
      });

      return toast.success('Challenge atualizado com sucesso.');
    } catch (error) {
      return toast.error('Erro ao atualizar o challenge, tente novamente');
    }
  }

  return (
    <>
      <Header>
        <ButtonTest type="submit" onClick={() => history.push('/level')}>
          <h2>Level</h2>
        </ButtonTest>
        <ButtonTest type="submit" onClick={() => history.push('/subject')}>
          <h2>Subject</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/module')}>
          <h2>Modules</h2>
        </ButtonTest>
        {/* <ButtonTest type="submit" onClick={() => history.push('/card')}>
          <h2>Cards</h2>
        </ButtonTest> */}

        <ButtonTest
          selected
          type="submit"
          onClick={() => history.push('/challenge')}
        >
          <h2>Challenges</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/jobs')}>
          <h2>Jobs</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/file')}>
          <h2>Files</h2>
        </ButtonTest>

        <ButtonTest type="submit" onClick={() => history.push('/users')}>
          <h2>Users</h2>
        </ButtonTest>
      </Header>

      <Container>
        <h1> Desafio:</h1>
        <div style={{ marginBottom: 60 }}>
          <p>Modulo: {module.title}</p>
          <p>Título: {challenge.title}</p>
          <p>Categoria: {challenge.type}</p>
          <p>Linguagem: {challenge.language}</p>
          <p>Pergunta: {challenge.question}</p>
          <p>Posicao: {challenge.position}</p>
          <p>Pre-Script:</p>
          <div style={{ marginLeft: 40 }}>
            <AceEditor
              placeholder="Placeholder 1Text"
              mode={challenge.language !== null ? challenge.language : 'html'}
              theme="dracula"
              fontSize={14}
              value={challenge.ace_editor !== null ? challenge.ace_editor : '.'}
              width="700px"
              height="300px"
            />
          </div>
          <p>Gabarito:</p>
          <div style={{ marginLeft: 40 }}>
            <AceEditor
              placeholder="gabarito do Desafio"
              mode={challenge.language !== null ? challenge.language : 'html'}
              theme="dracula"
              fontSize={14}
              value={challenge.answer !== null ? challenge.answer : '.'}
              width="700px"
              height="300px"
            />
          </div>
          <p>Texto de ajuda: {challenge.help}</p>
          <p>Youtube:</p>
          <div style={{ marginLeft: 40 }}>
            <YouTube
              videoId={`${challenge.description}`}
              opts={{ height: '390', width: '50%' }}
            />
          </div>
          <a href={`${challenge.link_question}`}>Link de Referência</a>
        </div>
        <h1>Editar Desafio:</h1>
        <form onSubmit={handleSubmit} style={{ paddingLeft: 40 }}>
          <div className="support">
            <div className="select">
              <p>Selecione o Tipo de Questāo:</p>
              <select value={type} onChange={handleSelectType}>
                <option value="code">CodePen</option>
                <option value="theory">Teórico</option>
              </select>
            </div>

            <span>Posicao do desafio:</span>
            <input
              value={position}
              type="text"
              placeholder="Posiçāo no Modulo"
              onChange={(event) => setPosition(event.target.value)}
            />

            <span>Titulo:</span>
            <input
              value={title}
              type="text"
              placeholder="Titulo"
              onChange={(event) => setTitle(event.target.value)}
            />

            <span>Pergunta:</span>
            <input
              value={question}
              type="text"
              placeholder="Pergunta"
              onChange={(event) => setQuestion(event.target.value)}
            />

            <span>Descriçāo:</span>
            <input
              value={description}
              type="text"
              placeholder="Descriçāo"
              onChange={(event) => setDescription(event.target.value)}
            />

            <span>Link Referencia:</span>
            <input
              value={link}
              type="text"
              placeholder="Link"
              onChange={(event) => setLink(event.target.value)}
            />

            <span>Linguagem:</span>
            <input
              value={language}
              type="text"
              placeholder="Linguagem"
              onChange={(event) => setLanguage(event.target.value)}
            />

            <span style={{ marginBottom: 10 }}>Texto de Ajuda:</span>
            <textarea
              value={textHelp}
              type="text"
              placeholder="Texto de auxilio para o desafio"
              onChange={(event) => setTextHelp(event.target.value)}
            />

            <span style={{ marginBottom: 10 }}>Pre-Script:</span>
            <AceEditor
              placeholder="Placeholder Text"
              mode={challenge.language !== null ? challenge.language : 'html'}
              theme="dracula"
              name={challenge.id ? challenge.id : ''}
              onLoad={onLoad}
              onChange={onChangeCode}
              fontSize={14}
              showPrintMargin
              showGutter
              highlightActiveLine
              value={code || 'Pre Script do Desafio'}
              width="700px"
              height="300px"
              setOptions={{
                enableBasicAutocompletion: true,
                enableLiveAutocompletion: true,
                enableSnippets: true,
                showLineNumbers: true,
                tabSize: 2,
              }}
            />
            <span style={{ marginBottom: 10 }}>Gabarito:</span>
            <AceEditor
              placeholder="Gabarito do Desafio"
              mode={challenge.language !== null ? challenge.language : 'html'}
              theme="dracula"
              name={challenge.id ? challenge.id : ''}
              onLoad={onLoad}
              onChange={onChangeAnswer}
              fontSize={14}
              showPrintMargin
              showGutter
              highlightActiveLine
              value={answer || 'Gabarito do Desafio'}
              width="700px"
              height="300px"
              // setOptions={{
              //   enableBasicAutocompletion: true,
              //   enableLiveAutocompletion: true,
              //   enableSnippets: true,
              //   showLineNumbers: true,
              //   tabSize: 2,
              // }}
            />
          </div>
          <button className="form" type="submit">
            ATUALIZAR
          </button>
        </form>
      </Container>
    </>
  );
}
